<template>
  <div>
    <div class="flex pb-4">
      <b-radio v-model="form.payer_type" native-value="empresa" class="pr-4">
        Pessoa Jurídica
      </b-radio>
      <b-radio v-model="form.payer_type" native-value="cliente">
        Pessoa física
      </b-radio>
    </div>
   

    <label
      class="flex flex-col pb-4"
      v-if="form.payer_type === 'empresa'"
    >
      <Lynx-Label label="Empresa" />
      <b-autocomplete
        required
        :data="filteredEmpresas"
        placeholder="Pesquise uma empresa"
        field="empresa"
        :loading="isFetching"
        @input="getAsyncEmpresa"
        @select="(option) => (form.payer_id = option.id)"
      />
    </label>
    <label
      class="flex flex-col pb-2"
      v-else-if="form.payer_type === 'cliente' "
    >
      <Lynx-Label label="Cliente" />
      <b-autocomplete
        required
        :data="filteredClientes"
        placeholder="Pesquise um Cliente"
        field="cliente"
        :loading="isFetching"
        @input="getAsyncCliente"
        @select="(option) => (form.payer_id = option.id)"
      />
    </label>
  </div>
</template>

<script>
import { searchEmpresasRequest } from "@/services/requests/empresas";
import { clientesSearchRequest } from "@/services/requests/clientes";
import debounce from "@/mixins/debounce";

export default {
  mixins: [ debounce],

  data() {
    return {
      form: {
        payer_type: "empresa",
        payer_id: null,
      },
      empresas: [],
      clientes: [],
      isFetching: false,
    };
  },
  watch: {
  'form.payer_id'() {
        this.$emit("payerEscolhido", this.form);
        this.form = {
        payer_type: "empresa",
        payer_id: null,
      };
    }
  },
    computed: {
    filteredEmpresas() {
      return this.empresas.map((item) => {
        return {
          id: item.id,
          empresa: `${item.id} - ${item.razao_social}`,
        };
      });
    },
    filteredClientes() {
      return this.clientes.map((item) => {
        return {
          id: item.id,
          cliente: `${item.id} - ${item.nome_completo}`,
        };
      });
    },
  },
  methods: {
    getAsyncEmpresa(name) {
      if (!name) return;
      let self = this;
      this.debounce(function () {
        self.isFetching = true;
        searchEmpresasRequest(name)
          .then((response) => {
            self.empresas = response.data.data;
          })
          .catch((error) => self.$snack.error(error.response.data.message))
          .finally(() => (self.isFetching = false));
      }, 600);
    },
    getAsyncCliente(name) {
      if (!name) return;
      let self = this;
      this.debounce(function () {
        self.isFetching = true;
        clientesSearchRequest(name)
          .then((response) => {
            self.clientes = response.data.data;
          })
          .catch((error) => self.$snack.error(error.response.data.message))
          .finally(() => (self.isFetching = false));
      }, 600);
    },
  },
};
</script>